import {SearchResultItemDefaultBox} from "./search-result-item.default.box";

export const SearchResultItemBox = SearchResultItemDefaultBox;